import memoize from 'lodash.memoize';


export const convertTransparencyToInt = memoize((alpha) => parseInt(alpha * 100, 10));
export const convertTransparencyToFloat = memoize((alpha) => parseFloat((alpha / 100).toFixed(2)));
